import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { useTranslation } from "react-i18next";

const TrendsTable = ({ tableData }) => {
  const { t } = useTranslation();

  const tableOptions = {
    noDataText: t("general.table.noDataAvailable"),
  };

  return (
    <>
      <BootstrapTable
        hover
        condensed
        search={false}
        bordered={false}
        data={tableData}
        deleteRow={false}
        insertRow={false}
        tableHeaderClass="mb-0"
        options={tableOptions}
      >
        <TableHeaderColumn width="100" dataField="artist_name" dataSort={true}>
          {t("trends.view.top10.table.column.artistName")}
        </TableHeaderColumn>
        <TableHeaderColumn width="100" dataField="song_name" dataSort={true}>
          {t("trends.view.top10.table.column.songMixName")}
        </TableHeaderColumn>
        <TableHeaderColumn width="100" dataField="number_of_sales" isKey={true} dataSort={true}>
          {t("trends.view.top10.table.column.numberOfSales")}
        </TableHeaderColumn>
      </BootstrapTable>
    </>
  );
};

export default TrendsTable;
